export const ECWID_CUSTOM_PAGE_TYPE = 'ECWID_CUSTOM_PAGE_TYPE';
export const ECWID_NATIVE_PAGE_TYPE = 'ECWID_NATIVE_PAGE_TYPE';
